import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import logo from "../assets/logo.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const linkClass = (path) =>
    `text-sm font-medium transition-colors px-3 py-2 rounded-md ${
      location.pathname === path
        ? "text-primary-700 bg-primary-50"
        : "text-neutral-700 hover:text-primary-700 hover:bg-neutral-100"
    }`;

  return (
    <nav className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-neutral-200">
      <div className="container">
        <div className="flex justify-between h-16 items-center">
          <Link to="/" className="flex items-center space-x-3">
            <img src={logo} alt="Sri Venkateswara Colleges" className="h-10 w-10 object-contain" />
            <span className="text-lg md:text-xl font-semibold text-neutral-900">Sri Venkateswara College</span>
          </Link>
          <div className="hidden md:flex items-center space-x-1">
            <Link to="/" className={linkClass("/")}>Home</Link>
            <Link to="/about" className={linkClass("/about")}>About</Link>
            <Link to="/academics" className={linkClass("/academics")}>Academics</Link>
            <Link to="/facilities" className={linkClass("/facilities")}>Facilities</Link>
            <Link to="/gallery" className={linkClass("/gallery")}>Gallery</Link>
            <Link to="/contact" className={linkClass("/contact")}>Contact</Link>
          </div>
          <div className="md:hidden">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="inline-flex items-center justify-center rounded-md p-2 text-neutral-700 hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-primary-500"
              aria-label="Toggle menu"
            >
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {menuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M3 6h18M3 12h18M3 18h18" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-neutral-200 bg-white">
          <div className="container py-2 space-y-1">
            <Link to="/" className={linkClass("/")}>Home</Link>
            <Link to="/about" className={linkClass("/about")}>About</Link>
            <Link to="/academics" className={linkClass("/academics")}>Academics</Link>
            <Link to="/facilities" className={linkClass("/facilities")}>Facilities</Link>
            <Link to="/gallery" className={linkClass("/gallery")}>Gallery</Link>
            <Link to="/contact" className={linkClass("/contact")}>Contact</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
